"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectorFamily = exports.selector = exports.atomFamily = exports.atom = exports.useGotoRecoilSnapshot = exports.useRecoilCallback = exports.useRecoilSnapshot = exports.useRecoilValueLoadable = exports.useRecoilValue = exports.useResetRecoilState = exports.useSetRecoilState = exports.useRecoilStateLoadable = exports.useRecoilState = void 0;
const store_1 = require("./analytics/store");
const store_2 = require("./article/store");
const store_3 = require("./blog/store");
const store_4 = require("./cart/store");
const store_5 = require("./collection/store");
const store_6 = require("./customer/store");
const store_7 = require("./locale/store");
const store_8 = require("./page/store");
const store_9 = require("./product/store");
const store_10 = require("./shop/store");
const store_11 = require("./view/store");
const store_12 = require("./settings/store");
// just so that we don't need to imports in components
var recoil_1 = require("recoil");
Object.defineProperty(exports, "useRecoilState", { enumerable: true, get: function () { return recoil_1.useRecoilState; } });
Object.defineProperty(exports, "useRecoilStateLoadable", { enumerable: true, get: function () { return recoil_1.useRecoilStateLoadable; } });
Object.defineProperty(exports, "useSetRecoilState", { enumerable: true, get: function () { return recoil_1.useSetRecoilState; } });
Object.defineProperty(exports, "useResetRecoilState", { enumerable: true, get: function () { return recoil_1.useResetRecoilState; } });
Object.defineProperty(exports, "useRecoilValue", { enumerable: true, get: function () { return recoil_1.useRecoilValue; } });
Object.defineProperty(exports, "useRecoilValueLoadable", { enumerable: true, get: function () { return recoil_1.useRecoilValueLoadable; } });
Object.defineProperty(exports, "useRecoilSnapshot", { enumerable: true, get: function () { return recoil_1.useRecoilSnapshot; } });
Object.defineProperty(exports, "useRecoilCallback", { enumerable: true, get: function () { return recoil_1.useRecoilCallback; } });
Object.defineProperty(exports, "useGotoRecoilSnapshot", { enumerable: true, get: function () { return recoil_1.useGotoRecoilSnapshot; } });
Object.defineProperty(exports, "atom", { enumerable: true, get: function () { return recoil_1.atom; } });
Object.defineProperty(exports, "atomFamily", { enumerable: true, get: function () { return recoil_1.atomFamily; } });
Object.defineProperty(exports, "selector", { enumerable: true, get: function () { return recoil_1.selector; } });
Object.defineProperty(exports, "selectorFamily", { enumerable: true, get: function () { return recoil_1.selectorFamily; } });
// eslint-disable-next-line import/no-default-export
exports.default = {
    ...store_1.analyticsStore,
    ...store_2.articleStore,
    ...store_3.blogStore,
    ...store_4.cartStore,
    ...store_5.collectionStore,
    ...store_6.customerStore,
    ...store_7.localeStore,
    ...store_8.pageStore,
    ...store_9.productStore,
    ...store_10.shopStore,
    ...store_11.viewStore,
    ...store_12.settingsStore,
};
//# sourceMappingURL=store.js.map